import * as React from 'react';
import { Search, X } from 'lucide-react';
import { Button,Input } from 'shared-portal-components-v2';

import ExternalInvitationContactRow from '@/components/organism/CreateSix/steps/StepExternal/ExternalInvitationContactRow';
import type { ExternalInvitationContactRowModel } from '@/types/ExternalInvitationStep.types';
import { MIN_LEN } from '@/constants';
import { classNames } from '@/utils/classNames.utils';

export interface ExternalInvitationContactsPanelProps {
  isActive: boolean;
  tabId: string;
  panelId: string;

  contactsSearchValue: string;
  onContactsSearchValueChange: (nextValue: string) => void;

  contactRows: ExternalInvitationContactRowModel[];
  onAddContact: (contactId: string) => void;

  className?: string;
}

export function ExternalInvitationContactsPanel(props: ExternalInvitationContactsPanelProps): React.JSX.Element | null {
  const {
    isActive,
    tabId,
    panelId,
    contactsSearchValue,
    onContactsSearchValueChange,
    contactRows,
    onAddContact,
    className,
  } = props;

  if (!isActive) return null;

  return (
    <div id={panelId} role="tabpanel" aria-labelledby={tabId} className={classNames('space-y-3 mt-4 overflow-x-hidden', className)}>
      <div className="relative mb-3">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
        <Input
          value={contactsSearchValue}
          onChange={(event: { currentTarget: { value: string; }; }) => {
            onContactsSearchValueChange(event.currentTarget.value);
          }}
          placeholder="Search external contacts..."
          className="pl-9 h-10"
        />
        {contactsSearchValue.length > MIN_LEN ? (
          <Button
            type="button"
            variant="tertiary"
            aria-label="Clear search"
            onClick={() => {
              onContactsSearchValueChange('');
            }}
            className="absolute right-2 top-1/2 -translate-y-1/2 rounded-full h-6 w-6 p-0 text-muted-foreground hover:text-foreground"
          >
            <X className="h-3 w-3" />
          </Button>
        ) : null}
      </div>

      <div className="space-y-2 max-h-64 overflow-y-auto">
        {contactRows.map((contactRowModel) => (
          <ExternalInvitationContactRow
            key={contactRowModel.contactId}
            model={contactRowModel}
            onAdd={onAddContact}
          />
        ))}
      </div>
    </div>
  );
}

ExternalInvitationContactsPanel.displayName = 'ExternalInvitationContactsPanel';

export default ExternalInvitationContactsPanel;
